export default "__VITE_ASSET__DemdVF3F__"